import '../paedml-modal.tag'
import '../paedml-form-input.tag'

<paedml-modal-school-mdm>
  <paedml-modal prefix={opts.prefix} heading={opts.heading} opname={opname} edit={edit} selectedrowsfunc={opts.selectedrowsfunc} idcol={opts.idcol} idtextcol={opts.idtextcol}
    submitfunc={submitHandler}>
  
    <yield to="fields">
      <div class="paedml-input-group">
      <div class="pb-1">
          MDM Organisationsadministrator:
        </div>
        <div class="row">
          <div class="col-md-12">
            <paedml-form-input name="orgaAdminUsername" label="Benutzername" 
              readonly value={parent.data.orgaAdminUsername}
              />
          </div>
        </div>
        <div class="row">
        <div class="col-md-6">
            <paedml-form-input name="orgaAdminSurname" label="Nachname" 
              readonly value={parent.data.orgaAdminSurname}
              />
          </div>
          <div class="col-md-6">
            <paedml-form-input name="orgaAdminGivenName" label="Vorname" 
              readonly value={parent.data.orgaAdminGivenName}
              />
          </div>
        </div>
        <div class="row">
              <div class="col-sm-6">
                  <paedml-form-input name="orgaAdminPassword" ref="pwOrgaAdm"
                      label="Kennwort" 
                      type="password" inputid="pwOrgaAdm"
                      required data-msg="Bitte geben Sie ein Kennwort ein" 
                      data-rule-maxlength="64" data-msg-maxlength="Das Kennwort darf nicht mehr als 64 Zeichen enthalten!" 
                      data-rule-minlength="{parent.getMinPwLength()}" data-msg-minlength="Das Kennwort muss mindestens {parent.getMinPwLength()} Zeichen haben!" 
                      data-rule-minonecharnumsym data-msg-minonecharnumsym="Mindestens ein Kleinbuchstabe, ein Großbuchstabe, eine Ziffer und ein Sonderzeichen."
                  />
              </div>
              <div class="col-sm-6">
                  <paedml-form-input type="password" 
                      label="Kennwortbestätigung"
                      placeholder="Kennwort bestätigen"
                      required data-msg="Bitte bestätigen Sie das Kennwort" 
                      data-rule-equalto="#pwOrgaAdm" data-msg-equalto="Die Kennwörter stimmen nicht überein!" 
                  />
              </div>
          </div>
      </div>
    </yield>
  </paedml-modal>
    
    <script>
      import {autoMapRowToData} from '../../util/modal-util'

      this.session = Session
      this.opname = this.opts.opname
      this.api = this.opts.api

      this.settings = {
            minPwLength: 8
      }

      this.getMinPwLength = () => this.settings.minPwLength

      this.data = {
          schoolType: '',
          orgaAdminUsername: '',
          orgaAdminSurname: '',
          orgaAdminGivenName: 'MDM Admin'
      }

      this.on('dataRequested', (selectedRows) => {
          this.data.schoolType = selectedRows[0][1]
          this.data.orgaAdminUsername = `mdm-admin-${this.data.schoolType}-radm`
          this.data.orgaAdminSurname = this.data.schoolType
      })

      this.on('rowMappingRequested', cols => {
        autoMapRowToData(this, cols)
      })

      this.submitHandler = formData => {
          return this.api.saveSchoolSettings(formData.ids[0], formData)
            .then(rsp => {
              const [data, status] = rsp
              if (status.success) {
                
                this.parent.trigger('reloadTable')
                window.request.relogin()
                return this.opname + ' erfolgreich durchgeführt'
              }

              console.error('error-status', status)
              console.error('error-data', data)
              if (data.message) {
                return Promise.reject(data.message)
              }
              return Promise.reject('Fehler bei ' + this.opname + '!')
            })
        }

    </script>
</paedml-modal-school-mdm>
